// Service constant
const services = {
  adminService: '/v1/admin',
  projectService: '/v1/project',
  reportService: '/v1/report',
  templateV2Service: '/v2/template',
  projectV2Service: '/v2/project',
}

// Dropdown API Urls
export const dropdownAPIs = {
  dropdown: `${services.adminService}/dropdown`,
  userRoles: `${services.adminService}/dropdown/users/`,
  states: `${services.adminService}/dropdown/state`,
  cities: `${services.adminService}/dropdown/city`,
  templates: `${services.adminService}/dropdown/template`,
  categoryCode: `${services.adminService}/master/category-code/category-details`,
  locationFactor: zipCode =>
    `${services.adminService}/master/location-factor/zipCode/${zipCode}`,
  takeoff: `${services.adminService}/master/takeoff`,
  takeoffGrouping: `${services.adminService}/master/takeoff/takeoff-groups`,
  percentCompletes: `${services.adminService}/dropdown/percent-complete`,
  depreciationsValues: `${services.adminService}/master/depreciations/distinct-values`,
}

// Settings API Urls
export const settingAPIs = {
  getSetting: `${services.adminService}/setting`,
  updateSetting: `${services.adminService}/setting`,
  updateTakeoffYear: (id, year) =>
    `${services.adminService}/setting/${id}/takeoff-Year/${year}`,
}

// User API Urls
export const userAPIs = {
  sync: `${services.adminService}/users/sync`,
  list: `${services.adminService}/users/list`,
  details: `${services.adminService}/users/details`,
  login: `${services.adminService}/users/login`,
  role: (userId, roleId) =>
    `${services.adminService}/users/${userId}/role/${roleId}`,
  logOut: `${services.adminService}/users/logout`,
  updateBuildVersion: `${services.adminService}/users/version`,
}

// Master Data API Urls
export const masterAPIs = {
  updateMaster: type => `${services.adminService}/master/${type}`,
  deleteMaster: type => `${services.adminService}/master/delete/${type}`,
  download: `${services.adminService}/master/download`,
  import: (type, value) =>
    `${services.adminService}/master/import/${type}/${value}`,
  importMaster: type => `${services.adminService}/master/${type}/import`,
  export: (type, value) =>
    `${services.adminService}/master/export/${type}/${value}`,
  exportMaster: type => `${services.adminService}/master/${type}/export`,
  upload: `${services.adminService}/master/upload`,
  updateImport: type => `${services.adminService}/master/${type}/update`,
  exportUnit: `/units/export`,
  analysisType: {
    list: `${services.adminService}/master/analysis-type/list`,
    details: id => `${services.adminService}/master/analysis-type/${id}`,
  },
  assetClass: {
    list: `${services.adminService}/master/asset-class/list`,
    details: id => `${services.adminService}/master/asset-class/${id}`,
    add: `${services.adminService}/master/asset-class`,
    delete: `${services.adminService}/master/asset-class/delete`,
  },
  bank: {
    update: `${services.adminService}/master/bank`,
    delete: `${services.adminService}/master/bank/takeoff`,
  },
  bsuop: {
    list: `${services.adminService}/master/bsuop/list`,
    details: id => `${services.adminService}/master/bsuop/${id}`,
    add: `${services.adminService}/master/bsuop`,
    delete: `${services.adminService}/master/bsuop/delete`,
  },
  buildingUse: {
    list: `${services.adminService}/master/building-use/list`,
    details: id => `${services.adminService}/master/building-use/${id}`,
    add: `${services.adminService}/master/building-use`,
    delete: `${services.adminService}/master/building-use/delete`,
  },
  categoryCode: {
    list: `${services.adminService}/master/category-code/list`,
    details: id => `${services.adminService}/master/category-code/${id}`,
    add: `${services.adminService}/master/category-code`,
    delete: `${services.adminService}/master/category-code/delete`,
  },
  conditionFactor: {
    list: `${services.adminService}/master/condition-factors/list`,
    details: id => `${services.adminService}/master/condition-factors/${id}`,
    add: `${services.adminService}/master/condition-factors`,
    delete: `${services.adminService}/master/condition-factors/delete`,
  },
  constructionFactor: {
    list: `${services.adminService}/master/construction-quality-factors/list`,
    details: id =>
      `${services.adminService}/master/construction-quality-factors/${id}`,
    add: `${services.adminService}/master/construction-quality-factors`,
    delete: `${services.adminService}/master/construction-quality-factors/delete`,
  },
  contract: {
    list: `${services.adminService}/master/contract/list`,
    details: id => `${services.adminService}/master/contract/${id}`,
    add: `${services.adminService}/master/contract`,
    delete: `${services.adminService}/master/contract/delete`,
  },
  costIndex: {
    list: `${services.adminService}/master/historical-cost-index/list`,
    details: id =>
      `${services.adminService}/master/historical-cost-index/${id}`,
    add: `${services.adminService}/master/historical-cost-index`,
    delete: `${services.adminService}/master/historical-cost-index/delete`,
  },
  depreciation: {
    list: `${services.adminService}/master/depreciations/list`,
  },
  groupingBank: {
    list: `${services.adminService}/master/bank/grouping/list`,
    details: id => `${services.adminService}/master/bank/grouping/${id}`,
    add: `${services.adminService}/master/bank/grouping/`,
    export: `${services.adminService}/master/bank/grouping/export`,
    clone: id => `${services.adminService}/master/bank/grouping/${id}/clone`,
    takeoff: {
      add: id => `${services.adminService}/master/bank/grouping/${id}/takeoff`,
      update: id =>
        `${services.adminService}/master/bank/grouping/takeoff/${id}`,
      delete: `${services.adminService}/master/bank/grouping/takeoff/delete`,
      clone: id =>
        `${services.adminService}/master/bank/grouping/${id}/takeoffs/clone`,
      reorder: `${services.adminService}/master/bank/grouping/takeoffs/reorder`,
    },
  },
  locationFactor: {
    list: `${services.adminService}/master/location-factor/list`,
    details: id => `${services.adminService}/master/location-factor/${id}`,
    add: `${services.adminService}/master/location-factor`,
    delete: `${services.adminService}/master/location-factor/delete`,
  },
  structureProfile: {
    list: `${services.adminService}/master/structure-profiles/list`,
    details: id => `${services.adminService}/master/structure-profiles/${id}`,
  },
  takeoff: {
    list: `${services.adminService}/master/takeoff/list`,
    details: id => `${services.adminService}/master/takeoff/${id}`,
    add: `${services.adminService}/master/takeoff`,
    delete: `${services.adminService}/master/takeoff/delete`,
  },
  takeoffGrouping: {
    list: `${services.adminService}/master/takeoff-grouping/list`,
    details: id => `${services.adminService}/master/takeoff-grouping/${id}`,
    add: `${services.adminService}/master/takeoff-grouping`,
    delete: `${services.adminService}/master/takeoff-grouping/delete`,
  },
  tenantBank: {
    list: `${services.adminService}/master/bank/tenant/list`,
    details: id => `${services.adminService}/master/bank/tenant/${id}`,
    add: `${services.adminService}/master/bank/tenant`,
    delete: `${services.adminService}/master/bank/tenant/delete`,
    clone: id => `${services.adminService}/master/bank/tenant/${id}/clone`,
    export: `${services.adminService}/master/bank/tenant/export`,
    takeoff: {
      add: id => `${services.adminService}/master/bank/tenant/${id}/takeoff`,
      update: id => `${services.adminService}/master/bank/tenant/takeoff/${id}`,
      delete: `${services.adminService}/master/bank/tenant/takeoff/delete`,
      clone: id =>
        `${services.adminService}/master/bank/tenant/${id}/takeoffs/clone`,
      reorder: `${services.adminService}/master/bank/tenant/takeoffs/reorder`,
    },
    grouping: {
      add: id =>
        `${services.adminService}/master/bank/tenant/${id}/interior-grouping`,
      delete: `${services.adminService}/master/bank/tenant/interior-grouping/delete`,
      reorder: `${services.adminService}/master/bank/tenant/interior-grouping/reorder`,
      takeoff: {
        add: (groupId, id) =>
          `${services.adminService}/master/bank/tenant/${id}/interior-grouping/${groupId}/takeoff`,
        list: (groupId, id) =>
          `${services.adminService}/master/bank/tenant/${id}/interior-grouping/${groupId}`,
        clone: (groupId, id) =>
          `${services.adminService}/master/bank/tenant/${id}/interior-grouping/${groupId}/takeoffs/clone`,
      },
    },
  },
  tenantType: {
    list: `${services.adminService}/master/tenantType/list`,
    details: id => `${services.adminService}/master/tenantType/${id}`,
    add: `${services.adminService}/master/tenantType`,
    delete: `${services.adminService}/master/tenantType/delete`,
  },
  unit: {
    list: `${services.adminService}/master/units/list`,
    details: id => `${services.adminService}/master/units/${id}`,
    add: `${services.adminService}/master/units`,
    delete: `${services.adminService}/master/units/delete`,
  },
  columnSetting: {
    get: type => `${services.adminService}/master/column-settings/${type}`,
    update: type => `${services.adminService}/master/column-settings`,
  },
  releaseLog: {
    get: `${services.adminService}/master/releaseNotes`,
  },
}

// Project API Urls
export const projectAPIs = {
  columns: {
    list: type =>
      `${services.projectV2Service}/projects/table-column-setting/${type}`,
    update: `${services.projectV2Service}/projects/table-column-setting`,
  },
  dropdown: {
    list: (id, type) =>
      `${services.projectV2Service}/projects/${id}/master/dropdown/${type}`,
    reportType: id =>
      `${services.reportService}/reports/project/${id}/report-types`,
    costType: `${services.projectV2Service}/projects/master/cost-type`,
  },
  master: {
    assetClass: {
      list: id =>
        `${services.projectV2Service}/projects/${id}/master/asset-class/list`,
      add: id =>
        `${services.projectV2Service}/projects/${id}/master/asset-class`,
      details: (id, assetClassId) =>
        `${services.projectV2Service}/projects/${id}/master/asset-class/${assetClassId}`,
      delete: id =>
        `${services.projectV2Service}/projects/${id}/master/asset-class`,
    },
    bsuop: {
      list: id =>
        `${services.projectV2Service}/projects/${id}/master/BSUOP/list`,
      add: id => `${services.projectV2Service}/projects/${id}/master/BSUOP`,
      details: (id, bsuopId) =>
        `${services.projectV2Service}/projects/${id}/master/BSUOP/${bsuopId}`,
      delete: id => `${services.projectV2Service}/projects/${id}/master/BSUOP`,
    },
    categoryCode: {
      list: id =>
        `${services.projectV2Service}/projects/${id}/master/category-code/list`,
      add: id =>
        `${services.projectV2Service}/projects/${id}/master/category-code`,
      details: (id, categoryId) =>
        `${services.projectV2Service}/projects/${id}/master/category-code/${categoryId}`,
      delete: id =>
        `${services.projectV2Service}/projects/${id}/master/category-code`,
    },
    contract: {
      list: id =>
        `${services.projectV2Service}/projects/${id}/master/contract/list`,
      add: id => `${services.projectV2Service}/projects/${id}/master/contract`,
      details: (id, contractId) =>
        `${services.projectV2Service}/projects/${id}/master/contract/${contractId}`,
      delete: id =>
        `${services.projectV2Service}/projects/${id}/master/contract`,
    },
    takeoff: {
      list: id =>
        `${services.projectV2Service}/projects/${id}/master/takeoff/list`,
      add: id => `${services.projectV2Service}/projects/${id}/master/takeoff`,
      details: (id, takeoffId) =>
        `${services.projectV2Service}/projects/${id}/master/takeoff/${takeoffId}`,
      delete: id =>
        `${services.projectV2Service}/projects/${id}/master/takeoff`,
      save: (id, takeoffId) =>
        `${services.projectV2Service}/projects/${id}/master/takeoff/${takeoffId}`,
    },
    takeoffGrouping: {
      list: id =>
        `${services.projectV2Service}/projects/${id}/master/takeoff-grouping/list`,
      add: id =>
        `${services.projectV2Service}/projects/${id}/master/takeoff-grouping`,
      details: (id, groupingId) =>
        `${services.projectV2Service}/projects/${id}/master/takeoff-grouping/${groupingId}`,
      delete: id =>
        `${services.projectV2Service}/projects/${id}/master/takeoff-grouping`,
    },
    unit: {
      list: id =>
        `${services.projectV2Service}/projects/${id}/master/unit/list`,
      add: id => `${services.projectV2Service}/projects/${id}/master/unit`,
      details: (id, unitId) =>
        `${services.projectV2Service}/projects/${id}/master/unit/${unitId}`,
      delete: id => `${services.projectV2Service}/projects/${id}/master/unit`,
    },
  },
  project: {
    add: `${services.projectV2Service}/projects`,
    details: id => `${services.projectV2Service}/projects/${id}`,
    clone: id => `${services.projectV2Service}/projects/${id}/clone`,
    delete: id => `${services.projectV2Service}/projects/${id}`,
    list: `${services.projectV2Service}/projects/dashboard`,
    restore: id => `${services.projectV2Service}/projects/${id}/restore`,
    sidebar: id => `${services.projectV2Service}/projects/${id}/sidebar`,
    sync: id => `${services.projectV2Service}/projects/${id}/sync`,
    archive: id => `${services.projectV2Service}/projects/${id}/archive`,
    unarchive: id => `${services.projectV2Service}/projects/${id}/unarchive`,
    updateColumns: userId =>
      `${services.projectV2Service}/projects/${userId}/columns`,
    abort: id => `${services.projectV2Service}/projects/${id}/archive/abort`,
    timeLogs: projectNumber =>
      `${services.projectV2Service}/projects/time-log/${projectNumber}`,
    notes: {
      add: id => `${services.projectV2Service}/projects/${id}/notes`,
      list: id => `${services.projectV2Service}/projects/${id}/notes`,
    },
    asset: {
      add: id => `${services.projectV2Service}/projects/${id}/assets`,
      assets: id => `${services.projectV2Service}/projects/${id}/assets`,
      clone: (id, assetId) =>
        `${services.projectV2Service}/projects/${id}/assets/${assetId}/clone`,
      delete: id => `${services.projectV2Service}/projects/${id}/assets`,
      list: id => `${services.projectV2Service}/projects/${id}/assets/list`,
      update: (id, assetId) =>
        `${services.projectV2Service}/projects/${id}/assets/${assetId}`,
      saveAsTemplate: (id, assetId) =>
        `${services.projectV2Service}/projects/${id}/assets/${assetId}`,
      actualCost: {
        level: {
          add: (id, assetId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/actual-cost/levels`,
          delete: (id, assetId, levelId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/actual-cost/levels/${levelId}`,
          details: (id, assetId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/actual-cost/levels-details`,
          download: (id, assetId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/actual-cost/levels/download`,
          downloadLevelDetails: (id, assetId, levelId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/actual-cost/levels/${levelId}/download`,
          import: (id, assetId, levelId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/actual-cost/levels/${levelId}/import`,
          list: (id, assetId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/actual-cost/levels`,
          update: (id, assetId, levelId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/actual-cost/levels/${levelId}`,
          tile: {
            add: (id, assetId, levelId) =>
              `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/actual-cost/levels/${levelId}/tile`,
            delete: (id, assetId, levelId, tileId) =>
              `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/actual-cost/levels/${levelId}/tile/${tileId}`,
            update: (id, assetId, levelId) =>
              `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/actual-cost/levels/${levelId}/tile`,
            moveTile: (id, assetId, levelId) =>
              `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/actual-cost/levels/${levelId}/tile/move`,
            move: (id, assetId, levelId, tileId) =>
              `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/actual-cost/levels/${levelId}/tile/${tileId}/costs/move`,
          },
          takeoff: {
            add: (id, assetId, levelId, tileId) =>
              `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/actual-cost/levels/${levelId}/tile/${tileId}/takeoffs`,
            clone: (id, assetId, levelId, tileId) =>
              `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/actual-cost/levels/${levelId}/tile/${tileId}/takeoffs/clone`,
            delete: (id, assetId, levelId, tileId) =>
              `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/actual-cost/levels/${levelId}/tile/${tileId}/takeoffs`,
            list: (id, assetId) =>
              `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/actual-cost/takeoffs`,
            reorder: (id, assetId, levelId, tileId) =>
              `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/actual-cost/levels/${levelId}/tile/${tileId}/takeoffs/reorder`,
            update: (id, assetId, levelId, tileId) =>
              `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/actual-cost/levels/${levelId}/tile/${tileId}/takeoffs`,
          },
        },
      },
      analysisSheet: {
        takeoff: (id, assetId) =>
          `${services.projectV2Service}/projects/${id}/analysis-sheet/${assetId}/takeoffs`,
        clone: (id, assetId) =>
          `${services.projectV2Service}/projects/${id}/analysis-sheet/${assetId}/takeoffs/clone`,
        list: id =>
          `${services.projectV2Service}/projects/${id}/analysis-sheet/takeoffs`,
        reorder: id =>
          `${services.projectV2Service}/projects/${id}/analysis-sheet/reorder`,
        export: id =>
          `${services.projectV2Service}/projects/${id}/analysis-sheet/export`,
        reconcile: id =>
          `${services.projectV2Service}/projects/${id}/analysis-sheet/reconcile`,
      },
      buildingGeneral: {
        clone: (id, assetId, buildingId) =>
          `${services.projectV2Service}/projects/${id}/assets/${assetId}/building-general/${buildingId}/clone`,
        details: (id, assetId) =>
          `${services.projectV2Service}/projects/${id}/assets/${assetId}/building-general`,
        update: (id, assetId, buildingId) =>
          `${services.projectV2Service}/projects/${id}/assets/${assetId}/building-general/${buildingId}`,
        tenant: {
          add: (id, assetId, buildingId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/building-general/${buildingId}/tenants`,
          apply: (id, assetId, buildingId, tenantId, bankId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/building-general/${buildingId}/tenants/${tenantId}/bank/${bankId}`,
          bulkUpdate: (id, assetId, buildingId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/building-general/${buildingId}/tenants`,
          delete: (id, assetId, buildingId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/building-general/${buildingId}/tenants`,
          export: (id, assetId, buildingId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/building-general/${buildingId}/tenants/export`,
          import: (id, assetId, buildingId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/building-general/${buildingId}/tenants/import`,
          list: (id, assetId, buildingId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/building-general/${buildingId}/tenants`,
          saveAs: (id, assetId, buildingId, tenantId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/building-general/${buildingId}/tenants/${tenantId}/bank`,
          tenantApproach: (id, assetId, buildingId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/building-general/${buildingId}/tenants`,
          update: (id, assetId, buildingId, tenantId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/building-general/${buildingId}/tenants/${tenantId}`,
          cloneTenant: (id, assetId, buildingId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/building-general/${buildingId}/tenants/clone`,
          reorder: (id, assetId, buildingId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/building-general/${buildingId}/tenants/reorder`,
        },
      },
      buildingShell: {
        clone: (projectId, assetId, buildingId) =>
          `${services.projectV2Service}/projects/${projectId}/assets/${assetId}/building-shell/${buildingId}/clone`,
        details: (projectId, assetId) =>
          `${services.projectV2Service}/projects/${projectId}/assets/${assetId}/building-shell`,
        update: (id, assetId, buildingId) =>
          `${services.projectV2Service}/projects/${id}/assets/${assetId}/building-shell/${buildingId}`,
        takeoff: {
          add: (id, assetId, buildingId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/building-shell/${buildingId}/takeoffs`,
          clone: (projectId, assetId, buildingId) =>
            `${services.projectV2Service}/projects/${projectId}/assets/${assetId}/building-shell/${buildingId}/takeoffs/clone`,
          delete: (id, assetId, buildingId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/building-shell/${buildingId}/takeoffs`,
          list: (id, assetId, buildingId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/building-shell/${buildingId}/takeoffs`,
          update: (id, assetId, buildingId, takeoffId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/building-shell/${buildingId}/takeoffs/${takeoffId}`,
          reorder: (id, assetId, buildingId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/building-shell/${buildingId}/takeoffs/reorder`,
        },
      },
      columns: {
        list: id =>
          `${services.projectV2Service}/projects/${id}/table-column-setting`,
        update: id =>
          `${services.projectV2Service}/projects/${id}/table-column-setting`,
      },
      commonArea: {
        clone: (projectId, assetId, commonAreaId) =>
          `${services.projectV2Service}/projects/${projectId}/assets/${assetId}/common-area/${commonAreaId}/clone`,
        details: (projectId, assetId) =>
          `${services.projectV2Service}/projects/${projectId}/assets/${assetId}/common-area`,
        update: (id, assetId, commonAreaId) =>
          `${services.projectV2Service}/projects/${id}/assets/${assetId}/common-area/${commonAreaId}`,
        takeoff: {
          add: (id, assetId, commonAreaId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/common-area/${commonAreaId}/takeoffs`,
          clone: (projectId, assetId, commonAreaId) =>
            `${services.projectV2Service}/projects/${projectId}/assets/${assetId}/common-area/${commonAreaId}/takeoffs/clone`,
          delete: (id, assetId, commonAreaId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/common-area/${commonAreaId}/takeoffs`,
          list: (id, assetId, commonAreaId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/common-area/${commonAreaId}/takeoffs`,
          update: (id, assetId, commonAreaId, takeoffId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/common-area/${commonAreaId}/takeoffs/${takeoffId}`,
          reorder: (id, assetId, commonAreaId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/common-area/${commonAreaId}/takeoffs/reorder`,
        },
        grouping: {
          add: (id, assetId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/common-area/groupings`,
          delete: (id, assetId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/common-area/groupings`,
          saveAs: (id, assetId, commonAreaId, groupingId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/common-area/${commonAreaId}/groupings/${groupingId}`,
          update: (id, assetId, commonAreaId, groupingId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/common-area/${commonAreaId}/groupings/${groupingId}`,
          reorder: (id, assetId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/common-area/interior-grouping/reorder`,
        },
      },
      estimate: {
        list: (id, assetId) =>
          `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/estimates`,
        details: (id, assetId, estimateId) =>
          `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/estimates/${estimateId}`,
        add: (id, assetId) =>
          `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/estimates/estimateGroup`,
        update: (id, assetId) =>
          `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/estimates/estimateGroup`,
        delete: (id, assetId) =>
          `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/estimates/estimateGroup`,
        info: (id, assetId) =>
          `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/estimates/info`,
        costDetails: {
          delete: (id, assetId, groupId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/estimates/estimateGroup/${groupId}/cost-details`,
        },
        takeoff: {
          add: (id, assetId, groupId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/estimates/estimateGroup/${groupId}/takeoffs`,
          clone: (id, assetId, groupId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/estimates/estimateGroup/${groupId}/takeoffs/clone`,
          delete: (id, assetId, groupId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/estimates/estimateGroup/${groupId}/takeoffs`,
          update: (id, assetId, groupId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/estimates/estimateGroup/${groupId}/takeoffs`,
          template: (id, assetId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/estimates/template-takeoffs`,
          groupingBank: (id, assetId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/estimates/grouping-bank-takeoffs`,
          tenantBank: (id, assetId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/estimates/tenant-bank-takeoffs`,
          bankTakeoff: (id, assetId, groupId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/estimates/estimateGroup/${groupId}/bank-takeoff`,
          info: (id, assetId, groupId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/estimates/estimateGroup/${groupId}/info`,
        },
      },
      indirectCost: {
        info: (id, assetId) =>
          `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/indirects/info`,
        costDetails: {
          add: (id, assetId, costId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/indirects/${costId}/line-item`,
          delete: (id, assetId, costId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/indirects/${costId}/line-item`,
          list: (id, assetId, costTypeId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/indirects/cost-type/${costTypeId}`,
          standard: (id, assetId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/indirects/standard-view`,
          estimate: (id, assetId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/indirects/estimateGroup-view`,
        },
      },
      interiorInfo: {
        clone: (projectId, assetId, infoId, tenantId) =>
          `${services.projectV2Service}/projects/${projectId}/assets/${assetId}/interior-info/${infoId}/tenants/${tenantId}/clone`,
        details: (projectId, assetId) =>
          `${services.projectV2Service}/projects/${projectId}/assets/${assetId}/interior-info`,
        update: (id, assetId, infoId) =>
          `${services.projectV2Service}/projects/${id}/assets/${assetId}/interior-info/${infoId}`,
        takeoff: {
          add: (id, assetId, infoId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/interior-info/${infoId}/takeoffs`,
          clone: (projectId, assetId, infoId) =>
            `${services.projectV2Service}/projects/${projectId}/assets/${assetId}/interior-info/${infoId}/takeoffs/clone`,
          delete: (id, assetId, infoId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/interior-info/${infoId}/takeoffs`,
          list: (id, assetId, infoId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/interior-info/${infoId}/takeoffs`,
          update: (id, assetId, infoId, takeoffId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/interior-info/${infoId}/takeoffs/${takeoffId}`,
          reorder: (id, assetId, infoId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/interior-info/${infoId}/takeoffs/reorder`,
        },
        grouping: {
          add: (id, assetId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/interior-info/groupings`,
          delete: (id, assetId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/interior-info/groupings`,
          saveAs: (id, assetId, infoId, groupingId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/interior-info/${infoId}/groupings/${groupingId}`,
          update: (id, assetId, infoId, groupingId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/interior-info/${infoId}/groupings/${groupingId}`,
          reorder: (id, assetId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/interior-info/interior-grouping/reorder`,
        },
      },
      link: {
        list: (id, assetId) =>
          `${services.projectV2Service}/projects/${id}/assets/${assetId}/link`,
        link: (id, parentAssetId, linkAssetId) =>
          `${services.projectV2Service}/projects/${id}/assets/${parentAssetId}/link/${linkAssetId}`,
        linkMethod: (id, assetId) =>
          `${services.projectV2Service}/projects/${id}/assets/${assetId}/link`,
        unlink: (id, parentAssetId, unlinkAssetId) =>
          `${services.projectV2Service}/projects/${id}/assets/${parentAssetId}/unlink/${unlinkAssetId}`,
      },
      newConstbuildingGeneral: {
        tenant: {
          add: (id, assetId, buildingId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/building-general/${buildingId}/tenants`,
          bulkUpdate: (id, assetId, buildingId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/building-general/${buildingId}/tenants`,
          delete: (id, assetId, buildingId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/building-general/${buildingId}/tenants`,
          export: (id, assetId, buildingId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/building-general/${buildingId}/tenants/export`,
          import: (id, assetId, buildingId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/building-general/${buildingId}/tenants/import`,
          list: (id, assetId, buildingId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/building-general/${buildingId}/tenants`,
          update: (id, assetId, buildingId, tenantId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/building-general/${buildingId}/tenants/${tenantId}`,
          cloneTenant: (id, assetId, buildingId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/building-general/${buildingId}/tenants/clone`,
          reorder: (id, assetId, buildingId) =>
            `${services.projectService}/new-construction/projects/${id}/assets/${assetId}/building-general/${buildingId}/tenants/reorder`,
        },
      },
      newConstAnalysisSheet: {
        takeoff: id =>
          `${services.projectService}/new-construction/projects/${id}/analysis-sheet/takeoffs`,
        export: id =>
          `${services.projectService}/new-construction/projects/${id}/analysis-sheet/export`,
        reconcile: id =>
          `${services.projectService}/new-construction/projects/${id}/analysis-sheet/reconcile`,
      },
      report: {
        assetClass: id =>
          `${services.reportService}/reports/project/${id}/asset-class`,
        assetClasslist: id =>
          `${services.reportService}/reports/project/${id}/asset-class/list`,
        bonus: id => `${services.reportService}/reports/project/${id}/bonus`,
        column: (id, typeId) =>
          `${services.reportService}/reports/project/${id}/report-type/${typeId}/columns`,
        generate: id => `${services.reportService}/reports/project/${id}`,
        list: (id, reportTypeId) =>
          `${services.reportService}/reports/project/${id}/report-type/${reportTypeId}`,
        notes: id => `${services.reportService}/reports/project/${id}/notes`,
        preview: (id, reportTypeId) =>
          `${services.reportService}/reports/project/${id}/report-type/${reportTypeId}/report`,
        validateTakeoff: id =>
          `${services.reportService}/reports/project/${id}/validate-takeoffs`,
        reconcileReport: id =>
          `${services.reportService}/reports/project/${id}/reconcile`,
        conventions: id =>
          `${services.reportService}/reports/project/${id}/convention/dropdown`,
        convention: id =>
          `${services.reportService}/reports/project/${id}/convention`,
        methods: id =>
          `${services.reportService}/reports/project/${id}/method/dropdown`,
        method: id =>
          `${services.reportService}/reports/project/${id}/method`,
      },
      siteTakeoff: {
        clone: (projectId, assetId, siteId) =>
          `${services.projectV2Service}/projects/${projectId}/assets/${assetId}/site-takeoff/${siteId}/clone`,
        details: (projectId, assetId) =>
          `${services.projectV2Service}/projects/${projectId}/assets/${assetId}/site-takeoff`,
        update: (id, assetId, siteId) =>
          `${services.projectV2Service}/projects/${id}/assets/${assetId}/site-takeoff/${siteId}`,
        takeoff: {
          add: (id, assetId, siteId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/site-takeoff/${siteId}/takeoffs`,
          clone: (projectId, assetId, siteId) =>
            `${services.projectV2Service}/projects/${projectId}/assets/${assetId}/site-takeoff/${siteId}/takeoffs/clone`,
          delete: (id, assetId, siteId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/site-takeoff/${siteId}/takeoffs`,
          list: (id, assetId, siteId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/site-takeoff/${siteId}/takeoffs`,
          update: (id, assetId, siteId, takeoffId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/site-takeoff/${siteId}/takeoffs/${takeoffId}`,
          reorder: (id, assetId, siteId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/site-takeoff/${siteId}/takeoffs/reorder`,
        },
        grouping: {
          add: (id, assetId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/site-takeoff/groupings`,
          delete: (id, assetId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/site-takeoff/groupings`,
          saveAs: (id, assetId, siteId, groupingId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/site-takeoff/${siteId}/groupings/${groupingId}`,
          update: (id, assetId, siteId, groupingId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/site-takeoff/${siteId}/groupings/${groupingId}`,
          reorder: (id, assetId) =>
            `${services.projectV2Service}/projects/${id}/assets/${assetId}/site-takeoff/interior-grouping/reorder`,
        },
      },
    },
  },
  columnSetting: {
    get: id =>
      `${services.projectV2Service}/projects/${id}/table-column-setting`,
    update: id =>
      `${services.projectV2Service}/projects/${id}/table-column-setting`,
  },
}

// Template V2 APIs
export const templateAPIs = {
  columns: {
    list: `${services.templateV2Service}/templates/table-column-setting`,
    update: `${services.templateV2Service}/templates/table-column-setting`,
  },
  template: {
    getTemplates: `${services.templateV2Service}/templates/list`,
    getTemplateDetails: id => `${services.templateV2Service}/templates/${id}`,
    addTemplate: `${services.templateV2Service}/templates`,
    updateTemplate: id => `${services.templateV2Service}/templates/${id}`,
    deleteTemplate: `${services.templateV2Service}/templates`,
    getSidebarDetails: id =>
      `${services.templateV2Service}/templates/${id}/sidebar`,
    cloneTemplates: id => `${services.templateV2Service}/templates/${id}/clone`,
    publishTemplate: id => `${services.templateV2Service}/templates/${id}/publish`,
    clonePublishTemplate: id => `${services.templateV2Service}/templates/${id}/publish/clone`,
    columns: {
      list: id =>
        `${services.templateV2Service}/templates/${id}/table-column-setting`,
      update: id =>
        `${services.templateV2Service}/templates/${id}/table-column-setting`,
    },
  },
  buildingGeneral: {
    getBuildingGeneralDetails: id =>
      `${services.templateV2Service}/templates/${id}/building-general`,
    updateBuildinggeneral: (id, buildingId) =>
      `${services.templateV2Service}/templates/${id}/building-general/${buildingId}`,
    tenant: {
      getTenantDetails: (id, buildingId) =>
        `${services.templateV2Service}/templates/${id}/building-general/${buildingId}/tenants`,
      addTenant: (id, buildingId) =>
        `${services.templateV2Service}/templates/${id}/building-general/${buildingId}/tenants`,
      updateTenant: (id, buildingId, tenantId) =>
        `${services.templateV2Service}/templates/${id}/building-general/${buildingId}/tenants/${tenantId}`,
      deleteTenant: (id, buildingId) =>
        `${services.templateV2Service}/templates/${id}/building-general/${buildingId}/tenants`,
      updateTenantApproach: (id, buildingId) =>
        `${services.templateV2Service}/templates/${id}/building-general/${buildingId}/tenants`,
      applyTenantBank: (id, buildingId, tenantId, bankId) =>
        `${services.templateV2Service}/templates/${id}/building-general/${buildingId}/tenants/${tenantId}/bank/${bankId}`,
      saveAsTenantBank: (id, buildingId, tenantId) =>
        `${services.templateV2Service}/templates/${id}/building-general/${buildingId}/tenants/${tenantId}/bank`,
      exportTenant: (id, buildingId) =>
        `${services.templateV2Service}/templates/${id}/building-general/${buildingId}/tenants/export`,
      importTenant: (id, buildingId) =>
        `${services.templateV2Service}/templates/${id}/building-general/${buildingId}/tenants/import`,
      bulkUpdateTenant: (id, buildingId) =>
        `${services.templateV2Service}/templates/${id}/building-general/${buildingId}/tenants`,
      cloneTenant: (id, buildingId) =>
        `${services.templateV2Service}/templates/${id}/building-general/${buildingId}/tenants/clone`,
      reorderTenant: (id, buildingId) =>
        `${services.templateV2Service}/templates/${id}/building-general/${buildingId}/tenants/reorder`,
    },
  },
  buildingShell: {
    getBuildingShellDetails: id =>
      `${services.templateV2Service}/templates/${id}/building-shell`,
    updateBuildingShell: (id, buildingId) =>
      `${services.templateV2Service}/templates/${id}/building-shell/${buildingId}`,
    getTakeoffs: (id, buildingId) =>
      `${services.templateV2Service}/templates/${id}/building-shell/${buildingId}/takeoffs`,
    addTakeoffs: (id, buildingId) =>
      `${services.templateV2Service}/templates/${id}/building-shell/${buildingId}/takeoffs`,
    updateTakeoffs: (id, buildingId, takeoffId) =>
      `${services.templateV2Service}/templates/${id}/building-shell/${buildingId}/takeoffs/${takeoffId}`,
    deleteTakeoffs: (id, buildingId) =>
      `${services.templateV2Service}/templates/${id}/building-shell/${buildingId}/takeoffs`,
    cloneTakeoffs: (id, buildingId) =>
      `${services.templateV2Service}/templates/${id}/building-shell/${buildingId}/takeoffs/clone`,
    reorderTakeoffs: (id, buildingId) =>
      `${services.templateV2Service}/templates/${id}/building-shell/${buildingId}/takeoffs/reorder`,
  },
  siteTakeoff: {
    getSiteTakeoffDetails: id =>
      `${services.templateV2Service}/templates/${id}/site-takeoff`,
    updateSiteTakeoff: (id, siteId) =>
      `${services.templateV2Service}/templates/${id}/site-takeoff/${siteId}`,
    getTakeoffs: (id, siteId) =>
      `${services.templateV2Service}/templates/${id}/site-takeoff/${siteId}/takeoffs`,
    addTakeoffs: (id, siteId) =>
      `${services.templateV2Service}/templates/${id}/site-takeoff/${siteId}/takeoffs`,
    updateTakeoffs: (id, siteId, takeoffId) =>
      `${services.templateV2Service}/templates/${id}/site-takeoff/${siteId}/takeoffs/${takeoffId}`,
    deleteTakeoffs: (id, siteId) =>
      `${services.templateV2Service}/templates/${id}/site-takeoff/${siteId}/takeoffs`,
    cloneTakeoffs: (id, siteId) =>
      `${services.templateV2Service}/templates/${id}/site-takeoff/${siteId}/takeoffs/clone`,
    reorderTakeoffs: (id, siteId) =>
      `${services.templateV2Service}/templates/${id}/site-takeoff/${siteId}/takeoffs/reorder`,
    grouping: {
      addGrouping: id =>
        `${services.templateV2Service}/templates/${id}/site-takeoff/groupings`,
      saveAsGrouping: (id, siteId, groupingId) =>
        `${services.templateV2Service}/templates/${id}/site-takeoff/${siteId}/groupings/${groupingId}`,
      updateGrouping: (id, siteId, groupingId) =>
        `${services.templateV2Service}/templates/${id}/site-takeoff/${siteId}/groupings/${groupingId}`,
      deleteGrouping: id =>
        `${services.templateV2Service}/templates/${id}/site-takeoff/groupings`,
      reorderGrouping: id =>
        `${services.templateV2Service}/templates/${id}/site-takeoff/interior-grouping/reorder`,
    },
  },
  specialtyInfo: {
    getSpecialtyInfoDetails: id =>
      `${services.templateV2Service}/templates/${id}/common-area`,
    updateSpecialtyInfo: (id, infoId) =>
      `${services.templateV2Service}/templates/${id}/common-area/${infoId}`,
    getTakeoffs: (id, infoId) =>
      `${services.templateV2Service}/templates/${id}/common-area/${infoId}/takeoffs`,
    addTakeoffs: (id, infoId) =>
      `${services.templateV2Service}/templates/${id}/common-area/${infoId}/takeoffs`,
    updateTakeoffs: (id, infoId, takeoffId) =>
      `${services.templateV2Service}/templates/${id}/common-area/${infoId}/takeoffs/${takeoffId}`,
    deleteTakeoffs: (id, infoId) =>
      `${services.templateV2Service}/templates/${id}/common-area/${infoId}/takeoffs`,
    cloneTakeoffs: (id, infoId) =>
      `${services.templateV2Service}/templates/${id}/common-area/${infoId}/takeoffs/clone`,
    reorderTakeoffs: (id, infoId) =>
      `${services.templateV2Service}/templates/${id}/common-area/${infoId}/takeoffs/reorder`,
    grouping: {
      addGrouping: id =>
        `${services.templateV2Service}/templates/${id}/common-area/groupings`,
      saveAsGrouping: (id, infoId, groupingId) =>
        `${services.templateV2Service}/templates/${id}/common-area/${infoId}/groupings/${groupingId}`,
      updateGrouping: (id, infoId, groupingId) =>
        `${services.templateV2Service}/templates/${id}/common-area/${infoId}/groupings/${groupingId}`,
      deleteGrouping: id =>
        `${services.templateV2Service}/templates/${id}/common-area/groupings`,
      reorderGrouping: id =>
        `${services.templateV2Service}/templates/${id}/common-area/interior-grouping/reorder`,
    },
  },
  interiorInfo: {
    getInteriorInfoDetails: id =>
      `${services.templateV2Service}/templates/${id}/interior-info`,
    updateInteriorInfo: (id, infoId) =>
      `${services.templateV2Service}/templates/${id}/interior-info/${infoId}`,
    getTakeoffs: (id, infoId) =>
      `${services.templateV2Service}/templates/${id}/interior-info/${infoId}/takeoffs`,
    addTakeoffs: (id, infoId) =>
      `${services.templateV2Service}/templates/${id}/interior-info/${infoId}/takeoffs`,
    updateTakeoffs: (id, infoId, takeoffId) =>
      `${services.templateV2Service}/templates/${id}/interior-info/${infoId}/takeoffs/${takeoffId}`,
    deleteTakeoffs: (id, infoId) =>
      `${services.templateV2Service}/templates/${id}/interior-info/${infoId}/takeoffs`,
    cloneTakeoffs: (id, infoId) =>
      `${services.templateV2Service}/templates/${id}/interior-info/${infoId}/takeoffs/clone`,
    reorderTakeoffs: (id, infoId) =>
      `${services.templateV2Service}/templates/${id}/interior-info/${infoId}/takeoffs/reorder`,
    grouping: {
      addGrouping: id =>
        `${services.templateV2Service}/templates/${id}/interior-info/groupings`,
      saveAsGrouping: (id, infoId, groupingId) =>
        `${services.templateV2Service}/templates/${id}/interior-info/${infoId}/groupings/${groupingId}`,
      updateGrouping: (id, infoId, groupingId) =>
        `${services.templateV2Service}/templates/${id}/interior-info/${infoId}/groupings/${groupingId}`,
      deleteGrouping: id =>
        `${services.templateV2Service}/templates/${id}/interior-info/groupings`,
      reorderGrouping: id =>
        `${services.templateV2Service}/templates/${id}/interior-info/interior-grouping/reorder`,
    },
  },
  analysisSheet: {
    getTakeoffs: id =>
      `${services.templateV2Service}/templates/${id}/analysis-sheet/takeoffs`,
    addTakeoffs: id =>
      `${services.templateV2Service}/templates/${id}/analysis-sheet/takeoffs`,
    updateTakeoffs: id =>
      `${services.templateV2Service}/templates/${id}/analysis-sheet/takeoffs`,
    deleteTakeoffs: id =>
      `${services.templateV2Service}/templates/${id}/analysis-sheet/takeoffs`,
    cloneTakeoffs: id =>
      `${services.templateV2Service}/templates/${id}/analysis-sheet/takeoffs/clone`,
    unlockTakeoffs: id =>
      `${services.templateV2Service}/templates/${id}/analysis-sheet/takeoffs`,
    export: id =>
      `${services.templateV2Service}/templates/${id}/analysis-sheet/export`,
  },
  columnSetting: {
    get: id =>
      `${services.templateV2Service}/templates/${id}/table-column-setting`,
    update: id =>
      `${services.templateV2Service}/templates/${id}/table-column-setting`,
    getDashboard: `${services.templateV2Service}/templates/table-column-setting`,
    updateDashboard: `${services.templateV2Service}/templates/table-column-setting`,
  },
}

// Master Data Screen Types
export const screenType = {
  analysisType: 'ANALYSIS_TYPE',
  assetClass: 'ASSET_CLASS',
  bsuop: 'BSUOP',
  buildingUse: 'BUILDING_USE',
  categoryCode: 'CATEGORY_CODE',
  conditionFactor: 'CONDITION_FACTOR',
  constructionQualityFactor: 'CONSTRUCTION_QUALITY_FACTOR',
  contract: 'CONTRACT',
  groupingBank: 'INTERIOR_GROUPING_BANK',
  historicalCostIndex: 'HISTORICAL_COST_INDEX',
  locationFactor: 'LOCATION_FACTOR',
  structureProfile: 'STRUCTURE_PROFILE',
  takeoff: 'TAKEOFF',
  takeoffGrouping: 'TAKEOFF_GROUPING',
  tenantBank: 'TENANT_BANK',
  tenantGroupingBank: 'TENANT_INTERIOR_GROUPING_BANK',
  unit: 'UNIT',
  tenantType: 'TENANT_TYPE',
  masterGroupingBank: 'GROUPING_BANK',
  depreciationSchedule: 'DEPRECIATION_SCHEDULE',
}
